import { motion, useMotionValue, useMotionTemplate } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PRODUCTS, WA } from "./data";
import { Reveal, Eyebrow, ease } from "./motion";

const Card = ({ p, i }) => {
  const x = useMotionValue(-400), y = useMotionValue(-400);
  const spot = useMotionTemplate`radial-gradient(420px circle at ${x}px ${y}px, rgba(255,176,32,0.28), transparent 60%)`;
  const onMove = (e) => { const r = e.currentTarget.getBoundingClientRect(); x.set(e.clientX - r.left); y.set(e.clientY - r.top); };
  return (
    <motion.a
      href={`${WA}`} target="_blank" rel="noreferrer" onMouseMove={onMove} onMouseLeave={() => { x.set(-400); y.set(-400); }}
      initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9, ease, delay: (i % 2) * 0.1 }}
      className={`group relative col-span-1 ${p.span} ${p.h} rounded-[28px] overflow-hidden bg-[#0A0E3F] isolate block`}
      data-testid={`product-card-${p.id}`}
    >
      <img src={p.img} alt={p.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-60 grayscale-[35%] scale-105 transition-[transform,opacity,filter] duration-[1.2s] ease-out group-hover:scale-110 group-hover:opacity-80 group-hover:grayscale-0" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0E3F] via-[#0A0E3F]/60 to-[#0A0E3F]/10" />
      <motion.div className="absolute inset-0 pointer-events-none" style={{ background: spot }} />
      <div className="relative h-full flex flex-col justify-between p-6 md:p-8">
        <div className="flex items-start justify-between">
          <span className="font-mono text-sm text-[#FFB020]">{p.n}</span>
          <span className="grid place-items-center w-11 h-11 rounded-full border border-white/30 text-white transition-[background-color,transform,border-color] duration-500 group-hover:bg-[#FF6A13] group-hover:border-[#FF6A13] group-hover:rotate-45">
            <ArrowUpRight className="w-5 h-5" />
          </span>
        </div>
        <div>
          <h3 className="font-display font-black text-white text-3xl md:text-4xl tracking-tight leading-[1]">{p.title}</h3>
          <p className="mt-3 max-w-md text-white/80 text-sm md:text-base leading-relaxed">{p.text}</p>
          <div className="mt-5 flex flex-wrap gap-2">
            {p.tags.map((t) => <span key={t} className="text-xs font-medium text-white/90 border border-white/25 rounded-full px-3 py-1 backdrop-blur-md bg-white/5">{t}</span>)}
          </div>
        </div>
      </div>
    </motion.a>
  );
};

export const Products = () => (
  <section id="produtos" className="relative bg-[#F4EFE6] py-24 md:py-36" data-testid="products-section">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="grid md:grid-cols-12 gap-8 mb-14 md:mb-20 items-end">
        <Reveal className="md:col-span-7">
          <Eyebrow dark>O que você encontra</Eyebrow>
          <h2 className="mt-6 font-display font-black text-[#0A0E3F] text-4xl sm:text-5xl lg:text-6xl tracking-[-0.03em] leading-[0.95]">
            Tudo para a água da sua casa, <span className="italic text-[#FF6A13]">num só balcão.</span>
          </h2>
        </Reveal>
        <Reveal className="md:col-span-5" delay={0.15}>
          <p className="text-base md:text-lg text-[#0A0E3F]/75 leading-relaxed">
            Não temos só um produto: trazemos uma solução. Da placa solar no telhado à última conexão do banheiro, a RSilva tem o item certo e a orientação de quem entende.
          </p>
        </Reveal>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5">
        {PRODUCTS.map((p, i) => <Card key={p.id} p={p} i={i} />)}
      </div>
    </div>
  </section>
);
